
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/index-b.html",
      function () {
        return require("private-next-pages/index-b.html.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/index-b.html"])
      });
    }
  